__turbopack_context__.v({
  "clamped": "-jXplW_clamped",
  "expanded": "-jXplW_expanded",
  "root": "-jXplW_root",
  "toggle": "-jXplW_toggle",
});
